// @ts-strict-ignore
import React, { useState } from 'react';
import { Card } from '@usealloy/component-library';

import DiligenceData from '~/entities/evaluations/DiligenceData/DiligenceData';
import { useFetchedUserContext } from '~/helpers/hooks';
import type { FeatureFlags } from '~/helpers/typescript';
import { hasDiligenceDataExcludingWatchlist } from '../../utils/cardDataChecks';
import { shouldRenderCard } from '../../utils/shouldRenderCard';

import { useEventTypeEvaluationsContext } from '../context';

const Diligence: React.FC = () => {
  const { evaluation, constructWatchlistMatchDataObject } = useEventTypeEvaluationsContext();
  const { feature_flags: featureFlags = {} as FeatureFlags } = useFetchedUserContext();

  const isWorkflowTypeJourneyRouter = evaluation.evaluation_type === 'journey_router';
  const isWorkflowTypeReconciliation = evaluation.evaluation_type === 'reconciliation';
  const hideEmptyCardsEnabled = !!featureFlags?.['remove-empty-cards'];
  const isWatchlistTabEnabled = !!featureFlags?.['event-eval-improvements'];

  const [matchInfo] = useState(constructWatchlistMatchDataObject(
    evaluation.final_response,
  ));

  // Show Diligence if:
  // - Has diligence response data
  // - Not a journey router or reconciliation workflow
  // - Watchlist tab is NOT enabled (if enabled, watchlist is in its own tab, hide Diligence)
  // - Card has non-watchlist data (or remove-empty-cards flag is off)
  const shouldShowDiligence = (
    evaluation.final_response
    && evaluation.final_response.diligence
    && !isWorkflowTypeJourneyRouter
    && !isWorkflowTypeReconciliation
    && !isWatchlistTabEnabled
    && shouldRenderCard(hasDiligenceDataExcludingWatchlist(evaluation), hideEmptyCardsEnabled)
  );

  if (!shouldShowDiligence) {
    return null;
  }

  return (
    <Card
      header="Diligence"
      collapsible
    >
      <DiligenceData
        containsWatchlistMatch={matchInfo.length > 0}
        hideFinancial={featureFlags?.['credit-panel']}
        response={evaluation.final_response}
        evaluationToken={evaluation.evaluation_token}
      />
    </Card>
  );
};

export default Diligence;
